import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BmarkSpotRiskTraderGroupRendererComponent } from "app/bfx-bmark-summary/blotters/spot-risk/renderers/bmark-spot-risk-trader-group-renderer.component";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BmarkFwdRiskDisplayModel } from "shared/cubiq-services/model/benchmarks/BmarkSpotRiskDisplay.model";

/**
 * Extension to Spot Risk trader group total renderer - as Spot Totals represent the opposite risk side, we must
 * invert the intent of the order for non-zero amounts
 */

@Component({
  selector: "fwd-risk-trader-group",
  templateUrl: "./bmark-spot-risk-trader-group.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BmarkFwdRiskTraderGroupRendererComponent extends BmarkSpotRiskTraderGroupRendererComponent {
  constructor() {
    super();
  }

  protected processParams(params: any): void {
    super.processParams(params);
    if (!this.isZero && params.data instanceof BmarkFwdRiskDisplayModel) {
      const fwdModel: BmarkFwdRiskDisplayModel = params.data;
      if (fwdModel.getTenor() === CubiqTS.Tenor.SPOT) {
        this.isNegative = !this.isNegative;
      }
    }
  }

  /**
   * Need to negate all amounts for spot
   * @param value
   * @param displayZero
   * @param params
   * @returns
   */
  public override formatAmt(value: CubiqTS.BigNumber, displayZero: boolean, params: any): string {
    const fwdModel: BmarkFwdRiskDisplayModel = params.data;
    if (fwdModel.getTenor() === CubiqTS.Tenor.SPOT) {
      if (value instanceof CubiqTS.BigNumber && !value.isZero()) {
        return super.formatAmt(value.negated(), displayZero, params);
      }
    }
    return super.formatAmt(value, displayZero, params);
  }
}
